// src/components/Sellers.js
import React, { useEffect, useState } from "react";
import "../styles/Sellers.css";
import config from "../config";

export default function Sellers({ onViewPayouts }) {
  const [activeTab, setActiveTab] = useState("approved"); // approved | rejected | all
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadSellers = async (type) => {
    setLoading(true);

    let url = `${config.baseUrl}/api/admin/sellers`;

    if (type === "approved") url += "/approved";
    if (type === "rejected") url += "/rejected";

    try {
      const res = await fetch(url);

      if (!res.ok) {
        console.error("Failed to load sellers");
        setSellers([]);
        return;
      }

      const data = await res.json();
      setSellers(data);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSellers(activeTab);
  }, [activeTab]);

  const renderTabs = () => (
    <div className="seller-tabs">
      <button
        className={activeTab === "approved" ? "tab active" : "tab"}
        onClick={() => setActiveTab("approved")}
      >
        ✅ Approved Sellers
      </button>

      <button
        className={activeTab === "rejected" ? "tab active" : "tab"}
        onClick={() => setActiveTab("rejected")}
      >
        ❌ Rejected Sellers
      </button>

      <button
        className={activeTab === "all" ? "tab active" : "tab"}
        onClick={() => setActiveTab("all")}
      >
        📋 All Sellers
      </button>
    </div>
  );

  return (
    <div className="approved-sellers-container">
      <h2>Seller Management</h2>

      {renderTabs()}

      {loading ? (
        <p>Loading...</p>
      ) : sellers.length === 0 ? (
        <p>No sellers found.</p>
      ) : (
        <div className="approved-sellers-grid">
          {sellers.map((seller) => (
            <div className="approved-seller-card" key={seller.id}>
              <h3>{seller.name}</h3>

              <p><strong>Contact:</strong> {seller.contactName}</p>
              <p><strong>Email:</strong> {seller.email}</p>
              <p><strong>Phone:</strong> {seller.phoneNumber}</p>

              <p><strong>City:</strong> {seller.city}</p>
              <p><strong>State:</strong> {seller.state}</p>
              <p><strong>Pincode:</strong> {seller.pincode}</p>

              <p><strong>GST:</strong> {seller.gstNumber || "N/A"}</p>

              <p>
                <strong>Status:</strong>{" "}
                {seller.status === "ACTIVE" ? (
                  <span className="status-approved">Approved</span>
                ) : seller.status === "REJECTED" ? (
                  <span className="status-rejected">Rejected</span>
                ) : (
                  <span className="status-other">{seller.status}</span>
                )}
              </p>

              {/* NEW: View payouts button */}
              <button
                className="view-payouts-btn"
                onClick={() => onViewPayouts && onViewPayouts(seller.id, seller.name)}
              >
                💰 View Payouts
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
